module.exports = __webpack_public_path__ + "static/media/400095_02.b0b02f3e.png";